import { render, staticRenderFns } from "./companyDetailsTable.vue?vue&type=template&id=2b49fa9c&scoped=true&"
import script from "./companyDetailsTable.vue?vue&type=script&lang=js&"
export * from "./companyDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./companyDetailsTable.vue?vue&type=style&index=0&id=2b49fa9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b49fa9c",
  null
  
)

export default component.exports